

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { EsitoConsegnaInfratel } from "src/app/models/dto/esitoConsegnaInfratel.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { Timestamp } from 'firebase/firestore'; 
import { AppuntamentoFase2 } from "src/app/models/dto/appuntamentoFase2.model";
  

@Component({
    selector: "app-data-appuntamento-fase2",
    templateUrl: "./dialog-data_appuntamento_fase2.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogComunicaDataAppuntamentoFase2 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected comunicaDataAppuntamentoFase2Form: FormGroup;
    protected isComunicandoDataAppuntamentoFase2:boolean = false;
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      private messageService: MessageService,
    ) {
      this.pratica          = this.config.data.pratica;
      const dataAppuntamento = this.pratica.dataAppuntamentoFase2 
          ? this.convertFirestoreTimestampToDate(this.pratica.dataAppuntamentoFase2) 
          : null;
      this.comunicaDataAppuntamentoFase2Form = this.formBuilder.group({
        dataAppuntamento:        [ dataAppuntamento, [Validators.required]]
      });
      
    }
    ngOnInit() {
    }

    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isComunicandoDataAppuntamentoFase2 = true;
        let dataAppuntamento:AppuntamentoFase2 = new AppuntamentoFase2();
        dataAppuntamento.data = this.comunicaDataAppuntamentoFase2Form.get('dataAppuntamento').value;
        this.praticheService.comunicaAppuntamentoFase2(this.pratica.id, dataAppuntamento).subscribe( {
          next: (res) => {
            this.isComunicandoDataAppuntamentoFase2 = false;
            this.dialogRef.close({ success: true});
          },  error: (e) => {
            this.isComunicandoDataAppuntamentoFase2 = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di comunicazione della data dell'appuntamento di fase 2!",
              });
            this.dialogRef.close({ success: false });
          },
          complete: () => {

          }
        }
      );
       }
    }
  
  }